import script from "./PhotovoltaicMonitors.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhotovoltaicMonitors.vue?vue&type=script&setup=true&lang=ts"

import "./PhotovoltaicMonitors.vue?vue&type=style&index=0&id=48e7769a&lang=scss&scoped=true"

import exportComponent from "/Users/breeze/data/code/src/gitlab.goiot.net/chargingc/cms/web2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48e7769a"]])

export default __exports__